// Firebase Auth calls for Google sign-in.
// Popup first. If the browser blocks the popup, fall back to a full-page redirect.
import {
  GoogleAuthProvider,
  getRedirectResult,
  signInWithPopup,
  signInWithRedirect,
} from 'firebase/auth';
import { auth } from '../firebase';
import { isPopupBlockedError } from './googleAuth';

export function createGoogleProvider() {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });
  return provider;
}

export async function startGoogleSignIn() {
  const provider = createGoogleProvider();
  try {
    const result = await signInWithPopup(auth, provider);
    return { user: result?.user || null };
  } catch (error) {
    if (isPopupBlockedError(error)) {
      await signInWithRedirect(auth, provider);
      return { redirecting: true };
    }
    throw error;
  }
}

// One shared promise so React StrictMode does not consume the redirect result twice.
let redirectResultPromise = null;

export function resetGoogleRedirectResultForTests() {
  redirectResultPromise = null;
}

export function readGoogleRedirectResult() {
  if (!redirectResultPromise) {
    redirectResultPromise = getRedirectResult(auth).catch((error) => {
      redirectResultPromise = null;
      throw error;
    });
  }
  return redirectResultPromise;
}

export function googleCredentialFromError(error) {
  try {
    return {
      email: error?.customData?.email || '',
      credential: GoogleAuthProvider.credentialFromError(error),
    };
  } catch (_) {
    return { email: error?.customData?.email || '', credential: null };
  }
}
